import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

// export async function getApiOrder() {
//     try {
//         const response = await serviceContext.get(ReportsURL + "orders", null, options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };
export async function postApiOrder(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}bets/history`, JSON.stringify(data), options); //+ "orders", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
export async function postApiOrderCSVAll(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}bets/history/csv`, JSON.stringify(data), options); //+ "orders", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
// export async function postApiOrderCsv(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "orders/csv", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

// export async function postApiOrderPdf(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "orders/pdf", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function postUserList(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "userslist", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getEventListByEventTypeName(data) {
    try {
        const response = await serviceContext.post(`${ReportsURL}event/close` , JSON.stringify(data), options);//+ "orders/eventslist", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
export async function getMarketListByEventName(params) {
    try {
        const response = await serviceContext.post(`${ReportsURL}market/close`, JSON.stringify(params), options); //+ "orders/marketslist/" + event_name, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};